/**
 * List Schema of StatusSms
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {StatusSms} from '@/model/resource/StatusSms'

/* TODO: review generated schema */
export class ListStatusSmsSchema extends Schema {
  readonly name = 'ListStatusSms'

  readonly fieldSet: FieldSet<StatusSms> = {
    idStatusPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
